import Img from 'gatsby-image'
import React from 'react'
import { classes, mediumContainer } from '../utils/components'
import TextBlock from './text-block'
import styles from './profile-list.module.css'
import PropTypes from 'prop-types'

const ProfileList = ({ className, title, description, profiles }) => (
  <div className={classes(className)}>
    <div className="container">
      <h2>{title}</h2>
      <TextBlock className="my-8" text={description} />
    </div>
    {profiles &&
      profiles.map((profile, i) => (
        <div
          key={i}
          className={classes(mediumContainer, 'my-12 md:flex md:items-center')}
        >
          <Img fluid={profile.image.fluid} className={styles.image} />
          <div className="container mt-6 md:mt-0 md:p-0 md:pl-10">
            <h2>{profile.name}</h2>
            <div className="text-xl font-light text-primary-variant">
              {profile.jobTitle}
            </div>
            <TextBlock
              className="mt-6"
              colorClass="text-primary"
              fontClass="text-xl font-light"
              text={profile.descriptionNode}
            />
          </div>
        </div>
      ))}
  </div>
)

ProfileList.propTypes = {
  className: PropTypes.string,
  title: PropTypes.string,
  description: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  profiles: PropTypes.arrayOf(PropTypes.object),
}

export default ProfileList
